###
###
module.exports = Em.Service.extend
  init: ->
    @_super(arguments...)

  recaptchaInstance: null
  loadDeferred:  null

  retrieve: ->
    if @get('loadDeferred')
      return @get('loadDeferred').promise

    deferred = Em.RSVP.defer()
    @set('loadDeferred', deferred)

    callbackName = "__onRecaptchaInit_#{ Math.floor( Math.random() * 0xffffff ) }"

    window[ callbackName ] = =>
      @set('recaptchaInstance', window.grecaptcha)
      deferred.resolve( @get('recaptchaInstance'))

    Em.$.getScript("https://www.google.com/recaptcha/api.js?onload=#{ callbackName }&render=explicit")
    deferred.promise
